export default __webpack_public_path__ + "img/fos-open-scouting-logo.1caeefd3.svg";